import type { ReturnRecord } from '@/types';

/** Deterministic gradient for a product thumbnail placeholder. */
const AVATAR_GRADIENTS = [
  'from-blue-400 to-blue-600',
  'from-amber-500 to-amber-700',
  'from-emerald-400 to-emerald-600',
  'from-rose-400 to-rose-600',
  'from-violet-400 to-violet-600',
  'from-orange-400 to-orange-600',
];

export function avatarGradient(seed: string): string {
  let hash = 0;
  for (let index = 0; index < seed.length; index += 1) {
    hash = (hash + seed.charCodeAt(index)) % AVATAR_GRADIENTS.length;
  }
  return AVATAR_GRADIENTS[hash];
}

export function returnAmount(row: ReturnRecord): number | undefined {
  return row.netRefund ?? row.itemSubtotal ?? row.totalOrderValue;
}
